export default __webpack_public_path__ + "static/media/story-mobil1.9df5a2be.png";